<div class="hero-image full-screen-grid-buster" aria-hidden="true">
  <div class="hero-image__overlay"></div>
  <img class="hero-image__img" src="{{ imageSrc }}" />
</div>
